import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const MUST_CONTAIN_ALPHANUMERIC_MESSAGE =
  'Package name must contain at least one letter or number';

export const MUST_CONTAIN_LETTER_MESSAGE = 'Name must contain at least one letter';

export function isMeaningfulDisplayName(value: string): boolean {
  return /[a-zA-Z]/.test(String(value ?? '').trim());
}

export class DisplayNameValidator {
  /**
   * After trimming, the value must contain at least one letter or digit.
   * Allows mixed special characters (e.g. "50% Off", "Wash & Wax").
   */
  static mustContainAlphanumeric(control: AbstractControl): ValidationErrors | null {
    if (control.value === null || control.value === undefined || control.value === '') {
      return null;
    }

    const trimmed = control.value.toString().trim();
    if (!trimmed || !/[a-zA-Z0-9]/.test(trimmed)) {
      return {
        mustContainAlphanumeric: {
          value: control.value,
          message: MUST_CONTAIN_ALPHANUMERIC_MESSAGE,
        },
      };
    }

    return null;
  }

  static mustContainLetter(control: AbstractControl): ValidationErrors | null {
    if (control.value === null || control.value === undefined || control.value === '') {
      return null;
    }

    const trimmed = control.value.toString().trim();
    if (!trimmed || !isMeaningfulDisplayName(trimmed)) {
      return {
        mustContainLetter: {
          value: control.value,
          message: MUST_CONTAIN_LETTER_MESSAGE,
        },
      };
    }

    return null;
  }
}

/**
 * Factory for display/product names that must include at least one letter or number.
 */
export function mustContainAlphanumericValidator(): ValidatorFn {
  return DisplayNameValidator.mustContainAlphanumeric;
}

export function mustContainLetterValidator(): ValidatorFn {
  return DisplayNameValidator.mustContainLetter;
}
